import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('PopoverContentBody', slot);
}

export const popoverContentBodyClasses = generateUtilityClasses('PopoverContentBody', [
  'root',
  'message',
  'startIcon',
  'endIcon',
]);

export type PopoverContentBodyClasses = typeof popoverContentBodyClasses;
